import React, { useEffect, useState } from 'react';
import {
  Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  FormControlLabel, Grid, Switch, TextField,
} from '@mui/material';

const emptyDepartment = {
  code: '', name: '', parent_department: null, department_head: null, is_active: true,
};

const DepartmentDialog = ({ open, item, departments, employees, loading, onClose, onSave }) => {
  const [form, setForm] = useState(emptyDepartment);

  useEffect(() => {
    setForm(item ? {
      code: item.code || '',
      name: item.name || '',
      parent_department: item.parent_department || null,
      department_head: item.department_head || null,
      is_active: item.is_active !== false,
    } : emptyDepartment);
  }, [item, open]);

  const parentOptions = departments.filter((department) => department.id !== item?.id);
  const selectedParent = parentOptions.find((value) => value.id === form.parent_department) || null;
  const selectedHead = employees.find((value) => value.id === form.department_head) || null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{item ? 'Edit Department' : 'Add Department'}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12} sm={4}>
            <TextField fullWidth label="Code" value={form.code}
              onChange={(event) => setForm({ ...form, code: event.target.value })} />
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField fullWidth label="Name" value={form.name}
              onChange={(event) => setForm({ ...form, name: event.target.value })} />
          </Grid>
          <Grid item xs={12}>
            <Autocomplete options={parentOptions} value={selectedParent}
              getOptionLabel={(option) => `${option.code} — ${option.name}`}
              onChange={(_event, value) => setForm({ ...form, parent_department: value?.id || null })}
              renderInput={(params) => <TextField {...params} label="Parent Department" />} />
          </Grid>
          <Grid item xs={12}>
            <Autocomplete options={employees} value={selectedHead}
              getOptionLabel={(option) => `${option.employee_no || ''} — ${option.name}`}
              onChange={(_event, value) => setForm({ ...form, department_head: value?.id || null })}
              renderInput={(params) => <TextField {...params} label="Department Head" />} />
          </Grid>
          {item && <Grid item xs={12}>
            <FormControlLabel control={<Switch checked={form.is_active}
              onChange={(event) => setForm({ ...form, is_active: event.target.checked })} />}
              label="Active" />
          </Grid>}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disabled={loading || !form.code.trim() || !form.name.trim()}
          onClick={() => onSave(form)}>{item ? 'Update' : 'Create'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DepartmentDialog;
